// DB module format
export interface EndpointsByActivePolicyResponse {
  data: EndpointsByActivePolicy[];
}

export interface EndpointsByActivePolicy {
  _id: string;
  serviceId: ServiceTargetIds;
  name: string;
  specifics: {
    endpointId: string;
  };
}

export enum ServiceTargetIds {
  CORE = 0,
  EPS = 1,
  SVE = 2,
  MDM = 4,
}
